import React, { createContext, useContext, useRef, useState } from "react";

const VoiceSessionContext = createContext(null);

export function VoiceSessionProvider({ children }) {
  const [activeConversationId, setActiveConversationId] = useState(null);
  const [activeMode, setActiveMode] = useState("balanced");
  const listenerRef = useRef(null);

  const notifyConversationCreated = (id) => {
    setActiveConversationId(id);
    if (listenerRef.current) listenerRef.current(id);
  };

  const registerConversationListener = (fn) => {
    listenerRef.current = fn;
  };

  return (
    <VoiceSessionContext.Provider
      value={{
        activeConversationId,
        setActiveConversationId,
        activeMode,
        setActiveMode,
        notifyConversationCreated,
        registerConversationListener,
      }}
    >
      {children}
    </VoiceSessionContext.Provider>
  );
}

export const useVoiceSession = () => useContext(VoiceSessionContext);
